import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

function VendorGallery({ vendorMediaList }) {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // Check if all images are loaded
  useEffect(() => {
    const imagePromises = vendorMediaList.map((image) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = image.path;
        img.onload = resolve;
        img.onerror = resolve; // Also resolve on error to avoid breaking on invalid images
      });
    });

    Promise.all(imagePromises).then(() => setImagesLoaded(true));
  }, [vendorMediaList]);

  const settings = {
    dots: false,
    fade: true,
    infinite: vendorMediaList.length > 1,  // Disable infinite scroll if only one image
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    autoplay: vendorMediaList.length > 1,  // Disable autoplay if only one image
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // For tablet or smaller screen sizes
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // For mobile or smaller screen sizes
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // For very small devices
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (!imagesLoaded) {
    return <div className="vendor-gallery-wrapper flex justify-center items-center">Loading...</div>; // Display a loading message or spinner until images are loaded
  }

  return (
    <div className="slider-container vendor-gallery-wrapper">
      <Slider {...settings}>
        {vendorMediaList.map((image, index) => (
          <div key={index} >
            {/* <LightGallery
              plugins={[lgZoom, lgVideo]}
              mode="lg-fade"
              pager={false}
              thumbnail={true}
              galleryId={'nature'}
              autoplayFirstVideo={false}
              elementClassNames={'gallery'}
              mobileSettings={{
                controls: false,
                showCloseIcon: false,
                download: false,
                rotate: false,
              }}
            > */}
            <a
              data-lg-size="1600-1144"
              data-pinterest-text="Pin it3"
              data-tweet-text="lightGallery slide  4"
              className="gallery__item"
              data-src={`${image.path}`}
              data-sub-html="<h4>Photo by - <a href='https://unsplash.com/@aaronburden' >Aaron Burden</a></h4><p>Location - <a href='https://unsplash.com/s/photos/grayling%2C-michigan%2C-united-states'>Grayling, Michigan, United States</a> Colorful trees near a lake. <a href='https://unsplash.com/photos/00QWN1J0g48'>Link</a> </p>"
            >
              <img src={image.path} alt={`Image ${index + 1}`} />
            </a>
            {/* </LightGallery> */}
          </div>
        ))}
      </Slider>
      <div className="flex justify-center items-center h-[470px]">
        {vendorMediaList.length ==0 ? <p>no images available</p> : ''}
      </div>
      
    </div>
  );
}

export default VendorGallery;



// const images = [
//   { src: "http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg", alt: "1" },
//   { src: "http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg", alt: "2" },
//   { src: "http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg", alt: "3" },
//   { src: "http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg", alt: "1" },
//   { src: "http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg", alt: "2" },
//   { src: "http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg", alt: "3" },
// ];

// import React, { useState } from "react";
// import Slider from "react-slick";

// function VendorGallery({vendorMediaList}) {
//   const [display, setDisplay] = useState(true);
//   const [width, setWidth] = useState(600);

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1
//   };
//   return (
//     <>
//     <div className="slider-container">
//       {/* <h2> Resizable Collapsible </h2>
//       <button className="button" onClick={() => setWidth(width + 100)}>
//         {" "}
//         increase{" "}
//       </button>
//       <button className="button" onClick={() => setWidth(width - 100)}>
//         {" "}
//         decrease{" "}
//       </button>
//       <button className="button" onClick={() => setDisplay(!display)}>
//         {" "}
//         toggle{" "}
//       </button> */}
//       <div
//         style={{
//           width: width + "px",
//           display: display ? "block" : "none"
//         }}
//       >
//         <Slider {...settings}>
//           {vendorMediaList.map((mediaData,index) => (
//           <div key={index}>
//             <img src="http://staging.familyfunaz.com/api/uploads/vendor_gallery_WzXq1P3Z.jpeg"/>
//             {/* <img src={mediaData.path}/> */}
//             {/* <h3>{mediaData.id}</h3> */}
//           </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//     </>
//   );
// }

// export default VendorGallery;  